import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow_down--sprite",
  "use": "arrow_down--sprite-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow_down--sprite\">\n    <path d=\"M30 21L24 27L18 21\" stroke=\"#3D3D3D\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol